import styled from 'styled-components';
import { theme } from 'theme';

export const LinkButton = styled.a`
  display: flex;
  width: 100%;
  height: 32px;
  align-items: center;
  justify-content: center;
  border-radius: 32px;
  background-color: ${theme.colors.purple};
  color: ${theme.colors.white};
  text-decoration: none;
  font-size: 13px;
  font-weight: bold;
  font-family: 'Noto Sans', sans-serif;
`;
